export default __webpack_public_path__ + "static/media/web_screen_chat_es.064c2033.png";